import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import ZohoCRM from "./pages/ZohoCRM";
import ZohoPartner from "./pages/ZohoPartner";
import ZohoDesk from "./pages/ZohoDesk";
import ZohoBooks from "./pages/ZohoBooks";
import ZohoProjects from "./pages/ZohoProjects";
import ZohoPeople from "./pages/ZohoPeople";
import ZohoVault from "./pages/ZohoVault";
import ZohoOrderManagement from "./pages/ZohoOrderManagement";
import ZohoOne from "./pages/ZohoOne";
import ZohoOneFunctionaliteiten from "./pages/ZohoOneFunctionaliteiten";
import Diensten from "./pages/Diensten";
import Contact from "./pages/Contact";
import Zoho from "./pages/Zoho";
import CRMSystemen from "./pages/CRMSystemen";

// Admin Pages
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/Dashboard";
import PagesList from "./admin/PagesList";
import PageEditor from "./admin/PageEditor";
import ImageManager from "./admin/ImageManager";
import FAQManager from "./admin/FAQManager";
import FooterManager from "./admin/FooterManager";
import Settings from "./admin/Settings";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
            {/* Admin Routes - NO Header/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pages"
              element={
                <ProtectedRoute>
                  <PagesList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pages/edit/*"
              element={
                <ProtectedRoute>
                  <PageEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/images"
              element={
                <ProtectedRoute>
                  <ImageManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/faqs"
              element={
                <ProtectedRoute>
                  <FAQManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/footer"
              element={
                <ProtectedRoute>
                  <FooterManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />

            {/* Public Routes - WITH Header/Footer */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            
            {/* Zoho Product Pages */}
            <Route path="/zoho-one" element={<PublicLayout><ZohoOne /></PublicLayout>} />
            <Route path="/zoho-one-functionaliteiten" element={<PublicLayout><ZohoOneFunctionaliteiten /></PublicLayout>} />
            <Route path="/zoho-crm" element={<PublicLayout><ZohoCRM /></PublicLayout>} />
            <Route path="/zoho-partner" element={<PublicLayout><ZohoPartner /></PublicLayout>} />
            <Route path="/zoho-desk" element={<PublicLayout><ZohoDesk /></PublicLayout>} />
            <Route path="/zoho-books" element={<PublicLayout><ZohoBooks /></PublicLayout>} />
            <Route path="/zoho-projects" element={<PublicLayout><ZohoProjects /></PublicLayout>} />
            <Route path="/zoho-people" element={<PublicLayout><ZohoPeople /></PublicLayout>} />
            <Route path="/zoho-vault" element={<PublicLayout><ZohoVault /></PublicLayout>} />
            <Route path="/zoho-order-management" element={<PublicLayout><ZohoOrderManagement /></PublicLayout>} />
            
            {/* SEO Landing Pages */}
            <Route path="/zoho" element={<PublicLayout><Zoho /></PublicLayout>} />
            <Route path="/zoho-crm-systeem" element={<PublicLayout><ZohoCRM /></PublicLayout>} />
            <Route path="/crm-software-zoho" element={<PublicLayout><ZohoCRM /></PublicLayout>} />
            <Route path="/crm-systemen" element={<PublicLayout><CRMSystemen /></PublicLayout>} />
            
            {/* Other Pages */}
            <Route path="/diensten" element={<PublicLayout><Diensten /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
